"use strict";

exports.__esModule = true;
exports.default = void 0;
var _reactEmotion = _interopRequireDefault(require("react-emotion"));
var _base = _interopRequireDefault(require("../../shared/base"));
var _font = _interopRequireDefault(require("../../shared/font"));
var _H = require("./H1");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Text = /*#__PURE__*/
(0, _reactEmotion.default)('p', {
  target: "e1yfx4yw0"
})(_base.default, ";", _font.default, ";", _H.text, "\n\n\tmargin:", function (props) {
  return props.margin || '0.5rem 0';
}, ";font-size:", function (props) {
  return props.fontSize || '0.75rem';
}, ";line-height:", function (props) {
  return props.lineHeight || '1.1rem';
}, ";font-weight:", function (props) {
  return props.fontWeight || 'normal';
}, ";text-transform:", function (props) {
  return props.uppercase ? 'uppercase' : 'inherit';
}, ";text-align:", function (props) {
  return props.center ? 'center' : 'inherit';
}, ";");
var _default = Text;
exports.default = _default;